export default "__VITE_ASSET__DIf5Q5d0__"